package com.shreyasjoshi.components

import androidx.compose.runtime.*
import org.jetbrains.compose.web.dom.*
import com.shreyasjoshi.models.PortfolioData

@Composable
fun KnowledgeBaseSection(isDarkMode: Boolean) {
    val info = PortfolioData.personalInfo

    Section(
        attrs = {
            id("knowledge")
            classNames(
                "portfolio-section",
                "py-16", "px-4", "sm:px-6", "lg:px-8", "max-w-6xl", "mx-auto", "border-b", "transition-colors",
                if (isDarkMode) "border-white/10" else "border-slate-200"
            )
        }
    ) {
        Div(attrs = { classNames("space-y-8") }) {
            // Header
            Div(attrs = { classNames("space-y-2") }) {
                Div(attrs = { classNames("text-xs", "font-mono", "text-[#189AD3]", "tracking-widest", "uppercase") }) {
                    Text("05 // TECHNICAL REPOSITORY")
                }
                H2(
                    attrs = {
                        classNames(
                            "text-3xl", "font-bold", "tracking-tight",
                            if (isDarkMode) "text-white" else "text-slate-900"
                        )
                    }
                ) {
                    Text("Curated Knowledge Base & Engineering Notes")
                }
                P(
                    attrs = {
                        classNames(
                            "text-sm", "max-w-3xl",
                            if (isDarkMode) "text-white/60" else "text-slate-600"
                        )
                    }
                ) {
                    Text("Deep-dive architectural notes, AOSP debugging procedures, Android Automotive design patterns, and Kotlin engineering guides.")
                }
            }

            // Spotlight Banner
            Div(
                attrs = {
                    classNames(
                        "p-6", "sm:p-8", "rounded-sm", "border", "transition-all",
                        if (isDarkMode) "bg-[#0a0a0a] border-white/10 hover:border-[#189AD3]/40"
                        else "bg-slate-50 border-slate-200 hover:border-[#189AD3]/40"
                    )
                }
            ) {
                Div(attrs = { classNames("flex", "flex-col", "lg:flex-row", "items-start", "lg:items-center", "justify-between", "gap-6") }) {
                    Div(attrs = { classNames("space-y-3", "max-w-2xl") }) {
                        Div(attrs = { classNames("knowledge-status", "flex", "items-center", "gap-2") }) {
                            Span(
                                attrs = {
                                    classNames(
                                        "px-2", "py-0.5", "rounded-sm", "text-[10px]", "font-mono", "font-bold",
                                        "bg-[#189AD3]/10", "text-[#71C7EC]", "border", "border-[#189AD3]/30"
                                    )
                                }
                            ) {
                                Text("LIVE PLATFORM")
                            }
                            Span(
                                attrs = {
                                    classNames(
                                        "text-xs", "font-mono",
                                        if (isDarkMode) "text-white/50" else "text-slate-500"
                                    )
                                }
                            ) {
                                Text("notes.shreyasjoshi.in")
                            }
                        }

                        H3(
                            attrs = {
                                classNames(
                                    "text-xl", "font-bold",
                                    if (isDarkMode) "text-white" else "text-slate-900"
                                )
                            }
                        ) {
                            Text("Shreyas Joshi's Digital Knowledge Garden")
                        }

                        P(
                            attrs = {
                                classNames(
                                    "text-xs", "sm:text-sm", "leading-relaxed",
                                    if (isDarkMode) "text-white/70" else "text-slate-600"
                                )
                            }
                        ) {
                            Text("An open engineering documentation hub documenting practical learnings across AOSP source builds, Cuttlefish virtualized setups, Android Automotive OS service integrations, and clean architectural paradigms.")
                        }

                        // Topics List
                        Div(attrs = { classNames("flex", "flex-wrap", "gap-2", "pt-2") }) {
                            listOf("AAOS Architecture", "AOSP Internals", "Kotlin Coroutines", "Cuttlefish", "PlantUML", "SWE Traceability").forEach { topic ->
                                Span(
                                    attrs = {
                                        classNames(
                                            "px-2", "py-0.5", "rounded-sm", "text-[11px]", "font-mono", "border",
                                            if (isDarkMode) "bg-white/5 text-white/70 border-white/10"
                                            else "bg-white text-slate-700 border-slate-200"
                                        )
                                    }
                                ) {
                                    Text(topic)
                                }
                            }
                        }
                    }

                    A(
                        href = info.knowledgeBase,
                        attrs = {
                            classNames(
                                "px-6", "py-3", "rounded-sm", "bg-[#189AD3]", "hover:bg-[#107DAC]", "text-white",
                                "font-mono", "text-xs", "font-bold", "tracking-wider", "flex", "items-center", "gap-2", "whitespace-nowrap", "transition-all"
                            )
                        }
                    ) {
                        Text("VISIT KNOWLEDGE BASE ↗")
                    }
                }
            }
        }
    }
}


